<template>
    <div v-show="isActive" :class="['tab-pane fade', { 'show active': isActive }]">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'Tab',

        props: {
            id: { type: String, required: true },
            name: { type: String, required: true },
            selected: { type: Boolean, required: false, default: false }
        },

        data() {
            return {
                isActive: false
            }
        },

        computed: {
            href() {
                return '#' + this.id;
            }
        },

        mounted() {
            this.isActive = this.selected;
        }
    }
</script>